// extracted by css-extract-rspack-plugin
export default {"formElement":"formElement__BzHzD","formButton":"formButton__RLfrh"};